import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { API_SERVICE_BACKEND } from "src/config";

const EnableDisableUserModal = ({
  setOpen,
  open,
  getAllWhiteLabelClients,
  handleMenuClose,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setOpen({ open: false, data: null });
  };

  const handleAccountStatus = async () => {
    const requestData = {
      email: open.data?.email,
      accountStatus: open.data?.accountStatus === 1 ? 0 : 1,
    };

    try {
      setIsLoading(true);
      const url = `${API_SERVICE_BACKEND}/updateUserWhiteLabelAccess`;
      const response = await axios.put(url, requestData);
      const data = response.data;

      getAllWhiteLabelClients();
      handleClose();
      handleMenuClose();

      toast.success(
        data.message ||
          `User account ${
            data?.data?.accountStatus === 1 ? "enabled" : "disabled"
          } successfully.`
      );
    } catch (error) {
      const errorMessage =
        error.response?.data?.error || "An unexpected error occurred.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const isCurrentlyEnabled = open.data?.accountStatus === 1;

  return (
    <Dialog open={open.open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {isCurrentlyEnabled ? "Disable" : "Enable"} User?
      </DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent sx={{ py: 1 }}>
        <Typography variant="subtitle1" gutterBottom>
          {isCurrentlyEnabled
            ? "This user will no longer have access to the platform."
            : "This user will regain access to the platform."}
        </Typography>
        {isCurrentlyEnabled && (
          <Typography
            variant="subtitle1"
            color="textSecondary"
            sx={{ textDecoration: "underline" }}
          >
            Their subscription will remain active.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="outlined" className="glass-button-secondary-50">
          Close
        </Button>
        <Button
          onClick={handleAccountStatus}
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress color="inherit" size={25} />
          ) : (
            `${isCurrentlyEnabled ? "Disable" : "Enable"}`
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnableDisableUserModal;
